// -----------------------------------------------------------------------------
// Slider on the the page cooperation
// -----------------------------------------------------------------------------

// Slider widt icons
function cooSlider() {

  changeSlide = function (index, cl) {
    cl = (typeof cl == undefined) ? '.carousel.carousel-slide' : cl;
    $(cl).carousel('set', index);
  }

  $('.coo-slider__icons.carousel').carousel({
    onCycleTo: function (data) {
      changeSlide($(data).data('cindex'), '.coo-slider__captions');

      // Add class to elements
      $('.coo-slider__icon-item').removeClass('coo-slider__icon-item--2');
      $('.coo-slider__icon-item').removeClass('coo-slider__icon-item--3');
      $(data).removeClass('coo-slider__icon-item--2');
      $(data).removeClass('coo-slider__icon-item--3');

      if ($('.coo-slider__icon-item.active').index() == $('.coo-slider__icon-item:last').index()) {
        $('.coo-slider__icon-item:eq(0)').addClass('coo-slider__icon-item--2');
        $('.coo-slider__icon-item:eq(1)').addClass('coo-slider__icon-item--3');
      } else if ($('.coo-slider__icon-item.active').index() == $('.coo-slider__icon-item').last().prev().index()) {
        $('.coo-slider__icon-item:last').addClass('coo-slider__icon-item--2');
        $('.coo-slider__icon-item:eq(0)').addClass('coo-slider__icon-item--3');
      } else {
        $('.coo-slider__icon-item.active').next().addClass('coo-slider__icon-item--2');
        $('.coo-slider__icon-item.active').next().next().addClass('coo-slider__icon-item--3');
      }

      var prev = $(data).prev();
      if ($('.coo-slider__icon-item.active').index() == 0) {
        $('.coo-slider__icon-item').last().addClass('coo-slider__icon-item--2');
        $('.coo-slider__icon-item').last().prev().addClass('coo-slider__icon-item--3');
      } else if ($('.coo-slider__icon-item.active').index() == 1) {
        $('.coo-slider__icon-item').first().addClass('coo-slider__icon-item--2');
        $('.coo-slider__icon-item').last().addClass('coo-slider__icon-item--3');
      } else {
        prev.addClass('coo-slider__icon-item--2');
        prev.prev().addClass('coo-slider__icon-item--3');
      }
    }
  });

  $('.coo-slider__captions.carousel').carousel({
    fullWidth: true,
    padding: 40,
    onCycleTo: function (data) {
      changeSlide($(data).data('cindex'), '.coo-slider__icons');

      // Height slider
      var itemHeight = $(data).height();
      $('.coo-slider__captions.carousel').height(itemHeight);
    }
  });

  // move next carousel
  $('.coo-slider__nav--next').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.carousel').carousel('next');
  });

  // move prev carousel
  $('.coo-slider__nav--prev').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.carousel').carousel('prev');
  });

}